<template>
  <div>
    <ClientOnly>
      <van-back-top
        :target="props.target"
        right="16"
        :bottom="currentBottom"
        z-index="49"
        class="back-top-customer !size-8 !bg-white !rounded-[3px] !opacity-100"
      >
        <!-- eslint-disable-next-line vue/html-self-closing -->
        <img :src="icon_top_nor" class="w-4 h-4" alt="去顶部按钮" />
      </van-back-top>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts" name="CustomerBackTop">
  import icon_top_nor from '@/assets/images/layout/icon_top_nor.png'
  import { storeToRefs } from 'pinia'
  import { useRoute } from 'vue-router'

  const { showPolicyBubble: showBubble } = storeToRefs(useMySystemStore())

  const Route = useRoute()

  const isMembershipListPage = computed(
    () => Route.name === 'membershipList' || Route.name === 'companyList',
  )
  const isShopHomePage = computed(() => Route.name === 'shopHome')

  const currentBottom = computed(() => {
    if (showBubble.value) {
      return 110
    } else if (isMembershipListPage.value) {
      return 24
    } else if (isShopHomePage.value) {
      return 24
    }

    return props.bottom
  })

  const props = defineProps({
    bottom: {
      type: [String, Number],
      default: 68,
    },
    target: {
      type: Object,
      default: null,
    },
  })
</script>

<style scope lang="scss">
  .back-top-customer {
    box-shadow: 0 5px 27px 0 rgb(0 55 161 / 0.08);
  }
</style>
